import React, { Component } from 'react'
import { Button, message } from 'antd'
import axios from 'axios';
import { Utils as QbUtils, Query, Builder, AntdConfig } from '@react-awesome-query-builder/antd'
import '@react-awesome-query-builder/antd/css/styles.css'
import useBoundStore from '../store'
import initSqlJs from 'sql.js'

const InitialConfig = AntdConfig

const config = {
  ...InitialConfig,
  fields: {
    Run: { label: 'Run', type: 'text' },
    Assay_Type: {
      label: 'Assay Type', type: 'select', valueSources: ['value'],
      fieldSettings: { listValues: [{ value: 'WGS', title: 'WGS' }] }
    },
    BioProject: { label: 'BioProject', type: 'text' },
    curated_projects: { label: 'Curated Projects', type: 'boolean', operators: ['equal'], valueSources: ['value'] },
    Whether_correct: { label: 'Whether Correct', type: 'boolean', operators: ['equal'], valueSources: ['value'] },
    Paper_name: { label: 'Paper name', type: 'text' },
    Project_description: { label: 'Project Description', type: 'text' },
    BioSample: { label: 'BioSample', type: 'text' },
    Experiment: { label: 'Experiment', type: 'text' },
    Organism: { label: 'Organism', type: 'text' },
    geo_loc_name_country: { label: 'Country', type: 'text' },
    geo_loc_name_country_continent: { label: 'Continent', type: 'text' },
    lat_lon: { label: 'Lat Lon', type: 'text' },
    HOST: { label: 'HOST', type: 'text' },
    Sequencing_method: { label: 'Sequencing Method', type: 'text' },
    instrument: { label: 'Instrument', type: 'text' },
  }
}

const sqlJsConfig = {
  locateFile: file => `https://cdnjs.cloudflare.com/ajax/libs/sql.js/1.5.0/${file}`
}

const queryValue = { "id": QbUtils.uuid(), "type": "group" }

function withStore(Component) {
  return function WrappedComponent(props) {
    const store = useBoundStore()
    return <Component {...props} store={store} />
  }
}

class DemoQueryBuilder extends Component {
  state = {
    tree: QbUtils.checkTree(QbUtils.loadTree(queryValue), config),
    config: config,
    radio: 'a'
  }

  render = () => (
    <div>
      <Query {...config} value={this.state.tree} onChange={this.onChange} renderBuilder={this.renderBuilder} />
      {this.renderResult(this.state)}
    </div>
  )

  renderBuilder = (props) => (
    <div style={{
      padding: '22px 24px',
      background: '#f7f9fc',
    }}>
      <div className="query-builder qb-lite">
        <Builder {...props} />
      </div>
    </div>
  )

  renderResult = ({ tree: immutableTree, config }) => (
    <div style={{
      padding: '18px 24px 22px',
      background: '#ffffff',
      borderTop: '1px solid #e2e8f0',
    }}>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '16px'
      }}>
        <Button
          type="primary"
          size="large"
          style={{
            height: 44,
            borderRadius: 10,
            padding: '0 28px',
            fontWeight: 600,
            fontSize: 15
          }}
          onClick={this.onClick}
        >
          🔍 Search
        </Button>

        <div style={{ fontWeight: 500, color: '#444' }}>Query:</div>

        <div style={{
          flex: 1,
          minWidth: 200,
          padding: '10px 14px',
          backgroundColor: '#fff1f0',
          color: '#d32f2f',
          borderRadius: 8,
          fontFamily: 'Consolas, monospace',
          fontSize: 13,
          wordBreak: 'break-all',
          border: '1px solid #ffcdd2'
        }}>
          {JSON.stringify(QbUtils.sqlFormat(immutableTree, config))}
        </div>
      </div>
    </div>
  )

  onChange = (immutableTree, config) => {
    this.setState({ tree: immutableTree, config: config })
  }

  onClick = () => {
    const sql = JSON.stringify(QbUtils.sqlFormat(this.state.tree, this.state.config));
    if (typeof sql === 'undefined') {
      message.warning('Please select rules!');
      return;
    }

        // ✅ 查询开始：打开 loading
    this.props.store.setLoadingData(true);

    initSqlJs(sqlJsConfig).then(async function (SQL) {
      var queryData = {};
      if (!sql || sql === '{}') {
        queryData.query = 'SELECT * FROM sample_key_meta_info';
      } else {
        queryData.query = sql;
      }

      try {
        const res = await axios.post('/api/query', queryData, {
          headers: { 'Content-Type': 'application/json' },
        });
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          this.props.store.setQueryData(res.data);
        } else {
          message.warning('No results returned!');
        }
      } catch (e) {
        message.warning('No results returned!');
      } finally {
        // ✅ 查询结束：无论成功失败都关闭 loading
        this.props.store.setLoadingData(false);
      }
    }.bind(this));
  }
}

export default withStore(DemoQueryBuilder)